import React from 'react';

const PageCountSelect = ({ rowsPerPage, handleRowsChange }) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      <div className="flex items-center gap-3">
        <select
          value={rowsPerPage}
          onChange={handleRowsChange}
          className="
            bg-white border border-gray-300 
            text-gray-700 text-sm 
            rounded-lg 
            focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 
            block w-20 md:w-24 
            p-2.5 
            outline-none
            cursor-pointer
            hover:border-indigo-400
            transition-colors
          "
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>

        {/* Optional: you can add text if you want */}
        <span className="text-sm text-gray-600 whitespace-nowrap">
          rows per page
        </span>
      </div>
    </div>
  );
};

export default PageCountSelect;